module.exports = __webpack_public_path__ + "static/media/21ECLAC50.9a1173bc.jpg";